/**************************************************
 * Nombre:       Tabs_Sub_Categorias
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Tab, Tabs} from "@mui/material";
import {useContext} from "react";
import {contexApp} from "../../../../App";

const Tabs_Sub_Categorias = ({escogido, setEscogido}) => {
    const cData = useContext(contexApp)


    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 0}}
            >


                <Grid container size={{xs: 12, sm: 12, md: 10}} sx={{justifyContent: 'center'}}>


                    <Tabs value={escogido} onChange={(e, v) => setEscogido(v)} variant={'scrollable'}
                          allowScrollButtonsMobile

                    >

                        <Tab label={'Todo'} value={'Todo'} sx={{fontSize: 20}}/>

                        {cData.categorias.map((e, i) => (
                            <Tab label={e.nombre} value={e.nombre} sx={{fontSize: 20}}/>
                        ))}

                    </Tabs>

                </Grid>

            </Grid>

        </Grid>
    )

}
export default Tabs_Sub_Categorias